import * as yup from 'yup'
import { useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, FeildError, FormLabel, FileUploadProgressBar } from '../../../form/form-layout'

const UploadPPC = ({ Style, data, onClose = () => { }, onChange = () => { } }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const onSuccess = (message) => {
        setAlertData({ isShow: true, type: "success", message: message });
        formik.resetForm();
    };

    const onApplyError = (message) => {
        setAlertData({ isShow: true, type: "error", message: message })
    }

    const validationSchema = yup.object().shape({
        file: yup.mixed().required('This Field is required'),
    });

    const formik = useFormik({
        initialValues: {file: '',},
        validationSchema,
        onSubmit: async (values) => {
            let apiData = new FormData();
            apiData.append('file', values?.file);

            try {
                const apiRes = await apiCall({ method: "post", url: "import-ppc-excel-data", data: apiData })
                onSuccess(apiRes.message || "Excel Uploaded")
                formik.resetForm();
            } catch (error) {
                onApplyError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
                console.warn("Error : ", error)
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                <div className={Style.modal_body}>
                    <FormArea>
                        <FeildWraper width='100%'>
                            <FormLabel>Upload Excel</FormLabel>
                            <FileUploadProgressBar
                                // mode="multi"
                                isReturnFile={true}
                                onFileDelete={() => { formik.setFieldValue("file", "") }}
                                value={formik.values.file || []}
                                onChange={(uploadedFiles) => {
                                    console.log("uploadedFiles", uploadedFiles)
                                    formik.setFieldValue("file", uploadedFiles);
                                }}
                                loader={formik.values.file}
                            />
                            {formik.touched.file && formik.errors.file && (
                                <FeildError>{formik.errors.file}</FeildError>
                            )}
                        </FeildWraper>
                    </FormArea>
                </div>

                <div className={Style.modal_foot}>
                    <div className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}>Cancel</div>
                    <button type="submit" className={Style.dcmb__submit}>Submit</button>
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default UploadPPC